import type { ReactNode } from "react";

import type { ChatComposerApi } from "@/features/shared/chat-composer";
import type { ChannelComposerSlot } from "../_types/channel-surface";

/** A slot is either static markup or a function of the live composer. */
export function renderComposerSlot(
  slot: ChannelComposerSlot | undefined,
  composer: ChatComposerApi,
): ReactNode {
  return typeof slot === "function" ? slot(composer) : slot;
}
